import React, { useMemo, useState } from "react";
import style from "./style.module.scss"
import { useTheme } from "@material-ui/core/styles";
import "./tag-cloud.css"
import { Slider, Button, Select, MenuItem } from "@material-ui/core";
import WordsTable from "./words-table/WordsTable";
import HomeWordsCloud from "../../Home/HomeWordsCloud";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isObjectEmpty } from "../../../../utils";
import TagCloud from "react-tag-cloud";
import { dashboardSettermWordCount } from "../../../../actions";
import { useActions } from "../../../../utils/action-helper";
import config from '../../../../config'
import { ArrowDropDown } from "@material-ui/icons"

export default function VocabularyComponent({ combine }) {
    const [dictionary, setDictionary] = useState(false)
    const [funcWord, setFuncWord] = useState(false)
    const [terms, setTerms] = useState(20)
    const [maxTerms, setMaxTerms] = useState(100);
    const { theme: { bgColors, colors, borderColors } } = useTheme();
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const [sort, setSort] = useState("");
    const [wordBase, setWordBase] = useState(1)
    const { t } = useTranslation();
    const resultData = useSelector(state => state.analyseData.result.resultData);
    const termWordCount = useSelector(state => state.dashboardData.termWordCount);
    const analyseLanguage = useSelector(state => state.analyseData.result.benchmark.locale_name);
    const wordsCloudConfig = config.wordsCloudTemplate[analyseLanguage];

    const { actionDashboardSettermWordCount } = useActions({
        actionDashboardSettermWordCount: dashboardSettermWordCount
    })

    const handleWordLemmaBase = (e) => {
        setWordBase(e.target.value);
    }

    const addWordItem = (position, item) => {
        const jArrayToken = resultData['dataTokenizer'][position];
        if (wordsCloudConfig.ignoreTags.includes(jArrayToken.tag)) {
            return;
        }

        if (wordsCloudConfig.ignoreTypes.includes(jArrayToken.type)) {
            return;
        }

        const wordItem = {
            position,
            color: item.color,
            type: item.label,
            rotate: Math.random() > 0.8 ? 90 : 0
        };

        if (wordBase > 0) {
            if (wordsCloudConfig.ignoreWords.includes(jArrayToken.word)) {
                return;
            }
            wordItem.length = jArrayToken.word.length;
            wordItem.num = resultData['dataTokenizer'].filter(val => val.word === jArrayToken.word).length;
            wordItem.text = jArrayToken.word;
        } else {
            if (wordsCloudConfig.ignoreLemmas.includes(jArrayToken.lemma)) {
                return;
            }
            wordItem.length = jArrayToken.lemma.length;
            wordItem.num = resultData['dataTokenizer'].filter(val => val.lemma === jArrayToken.lemma).length;
            wordItem.text = jArrayToken.lemma === '@card@' ? '123...': jArrayToken.lemma;
        }
        return wordItem;
    };

    function calculateWordsCloud(resultData, sort, terms, funcWord) {

        let wordsWithFilters = [];
        wordsCloudConfig.catType.map((item) => {

            if ((sort === "" || sort === item.label ) && resultData?.[item.countData]?.length) {
                resultData[item.countData].map(position => {
                    const newItem = addWordItem(position, item);
                    if (newItem)
                        wordsWithFilters.push(newItem);
                });
            } else {
                console.log(`resultData does not have key: ${item.label} or it's empty`);
            }
        });

        // filter for function words
        if(sort === "") {
            const allFunctionWords = [];
            // if (funcWord) {
                // Add respective item of below array when if it is available:
            wordsCloudConfig.funcWordData.map((func) => {
                if (resultData[func]?.length) {
                    allFunctionWords.push(
                      ...resultData[func]
                    )
                }
            })
            // }

            const item = {label: 'All', color: "#172535"};
            for(let i = 0; i < resultData['dataTokenizer'].length; i++ ) {
                if (allFunctionWords.includes(i)) {
                    if(funcWord) {
                        continue;
                    } else {
                        item.label = 'Function';
                        item.color = "#656565";
                    }
                } else {
                    item.label = 'All';
                    item.color = "#172535";
                }
                // const newItem = addWordItem(i, { type:  itemType, color: itemType !== 'Function'? "#172535" : "#351a17" });
                const newItem = addWordItem(i, item);
                if (newItem)
                    wordsWithFilters.push(newItem);
            }

        }

        //  uniqueficalion
        wordsWithFilters = wordsWithFilters.filter((value, index, self) => {
            return self.findIndex(val => val.text === value.text) === index
        })

        // sort
        wordsWithFilters.sort((a, b) => a.num > b.num ? -1 : 1)

        // and set limit
        setMaxTerms(wordsWithFilters.length);
        wordsWithFilters = wordsWithFilters.slice(0, terms);

        // calculate word sizes
        const maxMinSize = wordsWithFilters.reduce((acc, val) => [acc[0] < val.num ? val.num : acc[0], acc[1] > val.num ? val.num : acc[1]], [0, 10000]);
        wordsWithFilters = wordsWithFilters.map(v => {
            return { ...v, fontSize: Math.ceil(v.num / (maxMinSize[0] / 50)) }
        })
        return wordsWithFilters;
    }

    // memorisation result
    const wordsWithFilters = useMemo(() => {
        if (!isObjectEmpty(resultData)) {
            return calculateWordsCloud(resultData, sort, terms, funcWord)
        }
        return []
    }, [resultData, sort, terms, funcWord, wordBase])

    function handleOnSetTerms(event, newValue) {
        setTerms(newValue);
        actionDashboardSettermWordCount(newValue)
    }

    return (
        <div className={`${style.vocabulary}`} style={{ backgroundColor: bgColors.bgPrimary0 }}>
            {!combine ? <>  <div className={`${style.head}`}>
                <h2 style={{ color: colors.colorText }}>{t("Vocabulary")}</h2>
                <div style={{ gridGap: "10px" }} className={`d-flex align-items-center`}>
                    <Select
                        value={wordBase}
                        onChange={handleWordLemmaBase}
                        disableUnderline={isContrast}
                        IconComponent={(props) => (
                            <ArrowDropDown {...props} style={{ color: colors.colorText }} />
                        )}
                        style={{ backgroundColor: isContrast ? bgColors.bgPrimary100 : bgColors.bgPrimary0, color: colors.colorText, border: isContrast ? `1px solid ${colors.colorText}` : "none", borderRadius: 10, padding: "5px 10px" }}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    backgroundColor: bgColors.bgPrimary200,
                                    color: colors.colorText,
                                    borderRadius: '10px',
                                },
                            },
                        }}
                    >
                        <MenuItem value={1}>{t('dashboard_wordcloud_wordbase')}</MenuItem>
                        <MenuItem value={0}>{t('dashboard_wordcloud_lemmabase')}</MenuItem>
                    </Select>

                    <Button style={{ backgroundColor: !dictionary ? isContrast ? bgColors.bgContrastProgress : bgColors.bgBlue1000 : bgColors.bgPrimary200, color: !dictionary ?  colors.colorTextReverse : colors.colorText }} onClick={() => setDictionary(s => !s)} variant="contained" className={`${style.wordsCloud}`}>{t("Word cloud")}</Button>
                    <Button style={{ backgroundColor: dictionary ? isContrast ? bgColors.bgContrastProgress : bgColors.bgBlue1000 : bgColors.bgPrimary200, color: dictionary ?  colors.colorTextReverse : colors.colorText }} onClick={() => setDictionary(s => !s)} variant="contained" className={`${style.wordsCloud}`}>{t("List view")}</Button>
                </div>
            </div>
                <div className={style.vocMain}>
                    {dictionary ?
                        <div className={`d-flex`} style={{ gridGap: 80 }}>
                            <WordsTable wordsWithFilters={wordsWithFilters} />
                        </div> :
                        <HomeWordsCloud wordsWithFilters={wordsWithFilters} />
                    }
                    <div className={style.legends} style={{ borderLeft: `3px solid ${borderColors.borderPrimary200}`}}>
                        <div className={`mb-4 d-flex flex-column`}>
                            <h4 className={`mb-2`} style={{ color: isContrast ? colors.colorText : colors.colorMutedText, borderBottom: `2px solid ${borderColors.borderPrimary200}` }}>{t("Parts of speech")}</h4>
                            {wordsCloudConfig.catType && wordsCloudConfig.catType.map((item, index) => (
                              <Button
                                key={'button_tag_' + index}
                                variant={sort !== item.label ? 'text' : 'contained'}
                                className={`d-flex justify-content-start p-0 pl-1`}
                                style={{color: sort !== item.label ? isContrast ? colors.colorText : item.color : colors.colorTextReverse, backgroundColor: sort === item.label ? isContrast ? bgColors.bgContrastProgress : bgColors.bgBlue1000 : bgColors.bgPrimary0}}
                                onClick={() => setSort(item.label)}
                              >{t(item.label)}</Button>
                            ))}
                            <Button variant={sort !== "" ? "text" : "contained"} style={{ backgroundColor: sort === "" ? isContrast ? bgColors.bgContrastProgress : bgColors.bgBlue1000 : bgColors.bgPrimary0, color: sort === "" ? colors.colorTextReverse : isContrast ? colors.colorText : colors.colorBlue1000}}
                                className={`d-flex justify-content-start p-0 pl-1`}
                                onClick={() => setSort("")}>{t("Show all")}</Button>
                        </div>
                        <div>
                            <h4 className={`mb-2`} style={{ color: isContrast ? colors.colorText : colors.colorMutedText, borderBottom: `2px solid ${borderColors.borderPrimary200}` }}>{t('filter')}</h4>
                            <Button className={`mb-3 d-flex p-1`} style={{ fontSize: 10, backgroundColor: funcWord ? isContrast ? bgColors.bgContrastProgress : bgColors.bgBlue1000 : bgColors.bgPrimary200, color: funcWord ? colors.colorTextReverse : colors.colorText }} variant={"contained"} onClick={() => setFuncWord(s => !s)}
                            >{t("without function words")}</Button>
                            <div>
                                <p className={`d-flex align-items-center`}
                                    style={{ color: isContrast ? colors.colorText : colors.colorMutedText }}>{t("Terms")}
                                    <input className={`ml-2`} max={maxTerms} style={{ width: "35px", outline: "none", backgroundColor: isContrast ? bgColors.bgPrimary600 : bgColors.bgPrimary0, color: colors.colorText, border: `1px solid ${colors.colorText}`, padding: "2px 5px"}}
                                        type="number" value={terms}
                                        onChange={e => setTerms(e.target.value)} /></p>
                                <Slider min={1} max={maxTerms} value={terms} onChange={handleOnSetTerms} style={{ color: isContrast ? colors.colorText : colors.colorBlue1000}} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
                :
                wordsWithFilters?.length && <div className={style.vocMain} style={{ height: "400px" }}>
                    <div className={"mainTagCloud"}>
                        <div className={"app-outer"}>
                            <div className={"app-inner"}>
                                <TagCloud className='tag-cloud' style={{ padding: 6, fontFamily: 'Roboto', width: "800px", marginLeft: "-120px" }}>
                                    {wordsWithFilters.map(w => (
                                        <div key={w.text} rotate={w.rotate} style={{
                                            fontSize: w.fontSize,
                                            fontWeight: "bolder",
                                            color: isContrast ? colors.colorText : w.color,
                                        }}>{w.text}</div>
                                    ))}
                                </TagCloud>
                            </div>
                        </div>
                    </div>
                    <div className={style.legends} style={{ borderLeft: `3px solid ${borderColors.borderPrimary200}`}}>
                        <div className={`mb-4 d-flex flex-column`} style={{ paddingBottom: "170px" }}>
                            <h4 className={`mb-2`} style={{ color: isContrast ? colors.colorText : colors.colorMutedText, borderBottom: `2px solid ${borderColors.borderPrimary200}` }}>{t("Parts of speech")}</h4>
                            <Button variant={sort !== "Adjectives" ? "text" : "contained"}
                                style={{ backgroundColor: sort === "Adjectives" ? isContrast ? bgColors.bgContrastProgress : bgColors.bgBlue1000 : bgColors.bgPrimary0, color: sort !== "Adjectives" ? isContrast ? colors.colorText : "#3fbdff" : colors.colorTextReverse }}
                                className={`d-flex justify-content-start p-0 pl-1`}
                                onClick={() => setSort("Adjectives")}>{t("Adjectives")}</Button>
                            <Button variant={sort !== "Nouns" ? "text" : "contained"}
                                className={`d-flex justify-content-start p-0 pl-1`}
                                style={{ backgroundColor: sort === "Nouns" ? isContrast ? bgColors.bgContrastProgress : bgColors.bgBlue1000 : bgColors.bgPrimary0, color: sort !== "Nouns" ? isContrast ? colors.colorText : "#415c98" : colors.colorTextReverse }}
                                onClick={() => setSort("Nouns")}>{t("Nouns")}</Button>
                            <Button variant={sort !== "Verbs" ? "text" : "contained"}
                                style={{ backgroundColor: sort === "Verbs" ? isContrast ? bgColors.bgContrastProgress : bgColors.bgBlue1000 : bgColors.bgPrimary0, color: sort !== "Verbs" ? isContrast ? colors.colorText : "#5e47d9" : colors.colorTextReverse }}
                                className={`d-flex justify-content-start p-0 pl-1`}
                                onClick={() => setSort("Verbs")}>{t("Verbs")}</Button>
                        </div>
                        <h4 style={{color: isContrast ? colors.colorText : colors.colorMutedText}}>
                            {t("numberOfWords_dashboard_pdf")}  : </h4> <b style={{color: isContrast ? colors.colorText : colors.colorMutedText}} > {termWordCount}
                        </b>
                    </div>
                </div>
            }
        </div>
    )
}
